module.exports = __webpack_public_path__ + "static/media/note-2.d6c00051.jpg";